export const isHTMLVideoElememt = (
  e: HTMLVideoElement | HTMLVideoElementWrappper,
): e is HTMLVideoElement => {
  return e.tagName.toLowerCase() === "video";
};

export interface HTMLVideoElementWrappper {
  videoWidth: number;
  videoHeight: number;

  requestPointerLock?: () => void;
  srcObject?: MediaStream;
  tagName: string;
  play: () => Promise<void>;
  getBoundingClientRect: () => DOMRect;

  //
  addEventListener<K extends keyof HTMLVideoElementEventMap>(
    type: K,
    listener: (this: HTMLVideoElement, ev: HTMLVideoElementEventMap[K]) => any,
    options?: boolean | AddEventListenerOptions,
  ): void;
  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions,
  ): void;
  removeEventListener<K extends keyof HTMLVideoElementEventMap>(
    type: K,
    listener: (this: HTMLVideoElement, ev: HTMLVideoElementEventMap[K]) => any,
    options?: boolean | EventListenerOptions,
  ): void;
  removeEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | EventListenerOptions,
  ): void;
}
